import React from 'react';
import {
  CREATIVE_EXPORT_SIZING,
  merchantLaunchConcepts,
} from '../content/facebookMerchantLaunchBundle';
import FacebookMerchantCreativeCard from '../components/marketing/FacebookMerchantCreativeCard';

/**
 * Export-only route (`/preview/creative-export`).
 *
 * Renders every campaign creative at the exact pixel size Meta recommends
 * (≥1080px wide), each inside a fixed-size frame. The creative is laid out at
 * its tuned CSS width and upscaled with `transform: scale()`, so the export is
 * pixel-identical to the preview — just at full resolution.
 *
 * The `scripts/export-creatives.mjs` Playwright script screenshots each
 * `[data-export-frame]` element to a PNG named by `exportFileName`.
 *
 * This route is intentionally chrome-free (no header/footer) and is not linked
 * anywhere — it exists only to be screenshotted.
 */
const CreativeExport: React.FC = () => (
  <div style={{ background: '#ffffff' }}>
    {merchantLaunchConcepts.flatMap((concept) =>
      concept.formats.map((format) => {
        const sizing = CREATIVE_EXPORT_SIZING[format.aspectRatio];
        const scale = sizing.pngWidth / sizing.cssWidth;

        return (
          <div
            key={format.id}
            data-export-frame={format.exportFileName}
            style={{
              width: `${sizing.pngWidth}px`,
              height: `${sizing.pngHeight}px`,
              overflow: 'hidden',
            }}
          >
            <div
              style={{
                width: `${sizing.cssWidth}px`,
                transform: `scale(${scale})`,
                transformOrigin: 'top left',
              }}
            >
              <FacebookMerchantCreativeCard
                concept={concept}
                format={format}
                bare
              />
            </div>
          </div>
        );
      }),
    )}
  </div>
);

export default CreativeExport;
